// WebSocket Hooks
export {
  useWebSocket,
  usePricesConnection,
  useTradesConnection,
  useUSPricesConnection,
} from './use-websocket';

// NATS Hooks
export { useNats, useNatsStatus } from './use-nats';

// Live Price Hooks (supports both Indian and US stocks)
export {
  useLivePrice,
  default,
  type UseLivePriceOptions,
} from './use-live-price';

// Live Depth Hooks
export { useLiveDepth, type UseLiveDepthOptions } from './use-live-depth';
export {
  useLivePriceMultiple,
  type UseLivePriceMultipleOptions,
} from './use-live-price-multiple';

// Re-export shared types for consumers
export type {
  IndianStocksOptions,
  USStocksOptions,
  IndianStocksMultipleOptions,
  USStocksMultipleOptions,
} from './use-live-price-utils';
